export const supportConstants = {
  LOADING: "SUP_LOADING",
  THREAD_LOADING: "SUP_THREAD_LOADING",
  GET_TICKETS: "SUP_GET_TICKETS",
  GET_TICKET_DETAILED: "SUP_GET_TICKET_DETAILED",
  GET_TICKET_THREAD: "SUP_GET_TICKET_THREAD",
  GET_STATS: "SUP_GET_STATS",
  GET_AGENTS: "SUP_GET_AGENTS",
  GET_MEMBER_360: "SUP_GET_MEMBER_360",
  GET_MEMBER_TICKETS: "SUP_GET_MEMBER_TICKETS",
  GET_REPORTS: "SUP_GET_REPORTS",
  CLEAR_TICKET_DETAILED: "SUP_CLEAR_TICKET_DETAILED",
  RESPONSE: "SUP_RESPONSE",
};
